// import { horizontalNavigation } from 'app/mock-api/common/navigation/data';
/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

export function defaultNavigation(userInfo: {role: string, group: string}, currentUrl: string, unseenAlerts: number): FuseNavigationItem[] {
    console.log(userInfo.role);

    const estaEnTickets = currentUrl.includes('/tickets');
    const ticketsBadge = !estaEnTickets && unseenAlerts > 0 ? {
        title: unseenAlerts.toString(),
        classes: 'px-2 bg-accent-500 text-white rounded-full text-xs',
    } : {};

    return [
        // {
        //     id: 'admin',
        //     title: 'Administrador',
        //     type: 'basic',
        //     icon: 'heroicons_outline:computer-desktop',
        //     link: '/admin',
        // },
        {
            id: 'principal',
            title: 'Principal',
            type: 'group',
            icon: 'heroicons_outline:home',
            children: [
                {
                    id: 'tickets',
                    title: 'Tickets',
                    type: userInfo.role.includes('admin') ? 'collapsable' : 'basic',
                    icon: 'heroicons_outline:clipboard-document-list',
                    link: '/tickets',
                    badge: ticketsBadge,
                    children: userInfo.role.includes('admin')
                        ? [
                            {
                                id: 'admin',
                                title: 'Listar tickets',
                                type: 'basic',
                                icon: 'heroicons_outline:clipboard-document-list',
                                link: '/tickets/lista',
                            },
                            {
                                id: 'admin.tipificaciones',
                                title: 'Tipificaciones',
                                type: 'basic',
                                icon: 'heroicons_outline:list-bullet',
                                link: '/tickets/tipificaciones',
                            },
                            {
                                id: 'admin.tags',
                                title: 'Etiquetas',
                                type: 'basic',
                                icon: 'heroicons_outline:tag',
                                link: '/tickets/etiquetas',
                            },
                        ]
                        : [],
                },
                {
                    id: 'financiadores',
                    title: 'Financiadores',
                    type: 'basic',
                    icon: 'heroicons_outline:briefcase',
                    link: '/financiadores',
                },
                {
                    id: 'prestadores',
                    title: 'Prestadores',
                    type: 'basic',
                    icon: 'heroicons_outline:user-group',
                    link: '/prestadores',
                },
                {
                    id: 'lugares-atencion',
                    title: 'Lugares de Atención',
                    type: 'basic',
                    icon: 'heroicons_outline:building-office-2',
                    link: '/lugares-de-atencion',
                },
                {
                    id: 'transacciones',
                    title: 'Transacciones',
                    type: 'basic',
                    icon: 'heroicons_outline:arrows-right-left',
                    link: '/transacciones',
                },
                {
                    id: 'operaciones',
                    title: 'Operaciones',
                    type: userInfo.group.includes('itc') ? 'collapsable' : 'basic',
                    icon: 'heroicons_outline:squares-2x2',
                    link: '/operaciones',
                    children: userInfo.group.includes('itc')
                        ? [
                            {
                                id: 'operaciones.pasaportes',
                                title: 'Pasaportes',
                                type: 'basic',
                                icon: 'heroicons_outline:credit-card',
                                link: '/operaciones/pasaportes',
                            },
                            {
                                id: 'operaciones.sistemas',
                                title: 'Sistemas',
                                type: 'basic',
                                icon: 'heroicons_outline:computer-desktop',
                                link: '/operaciones/sistemas',
                            },
                            {
                                id: 'operaciones.transcodificaciones',
                                title: 'Transcodificaciones',
                                type: 'basic',
                                icon: 'heroicons_outline:language',
                                link: '/operaciones/transcodificaciones',
                            },
                        ]
                        : [],
                },
            ],
        },

        {
            id: 'configuracion',
            title: 'Configuración',
            type: 'group',
            icon: 'heroicons_outline:home',
            children: [

                {
                    id: 'pruebas',
                    title: 'Pruebas',
                    type: 'basic',
                    icon: 'heroicons_outline:command-line',
                    link: '/pruebas',
                },
                {
                    id: 'estadisticas',
                    title: 'Estadísticas',
                    type: 'basic',
                    icon: 'heroicons_outline:chart-bar',
                    link: '/estadisticas',
                },
                {
                    id: 'contactos',
                    title: 'Contactos',
                    type: 'basic',
                    icon: 'heroicons_outline:phone',
                    link: '/contactos',
                },
                {
                    id: 'configuracion',
                    title: 'Configuración',
                    type: userInfo.group.includes('itc') ? 'collapsable' : 'basic',
                    icon: 'heroicons_outline:cog-6-tooth',
                    link: '/configuracion',
                    children: userInfo.group.includes('itc')
                        ? [
                            {
                                id: 'usuarios',
                                title: 'Usuarios',
                                type: 'basic',
                                icon: 'heroicons_outline:users',
                                link: '/configuracion/usuarios',
                                // hidden: () => role.includes('operador')
                            },
                            {
                                id: 'notificaciones',
                                title: 'Notificaciones de Nuvalid',
                                type: 'basic',
                                icon: 'heroicons_outline:bell',
                                link: '/configuracion/notificaciones',
                            },
                        ]
                        : [],
                },


                {
                    id: 'balanceo',
                    title: 'Balanceo',
                    type: userInfo.role.includes('admin') ? 'collapsable' : 'basic',
                    icon: 'heroicons_outline:scale',
                    link: '/balanceo',
                    children: userInfo.role.includes('admin')
                        ? [
                            {
                                id: 'administracionIIS',
                                title: 'Administración IIS',
                                type: 'basic',
                                icon: 'heroicons_outline:adjustments-horizontal',
                                link: '/balanceo/administracion-iis',
                            },
                            {
                                id: 'administracionServicios',
                                title: 'Administración servicios',
                                type: 'basic',
                                icon: 'heroicons_outline:server',
                                link: '/balanceo/administracion-servicios',
                            },
                        ]
                        : [],
                },

                {
                    id: 'asociaciones',
                    title: 'Asociaciones',
                    type: 'basic',
                    icon: 'heroicons_outline:squares-plus',
                    link: '/asociaciones',
                },
                {
                    id: 'ayuda',
                    title: 'Ayuda',
                    type: 'basic',
                    icon: 'heroicons_outline:information-circle',
                    link: '/ayuda',
                },
            ],
        },
    ];
}

export function defaultExternalNavigation(role: string): FuseNavigationItem[] {
    return [
        {
            id: 'prestadores',
            title: 'Prestadores',
            type: 'basic',
            icon: 'heroicons_outline:user-group',
            link: '/prestadores',
        },
        {
            id: 'lugares-atencion',
            title: 'Lugares de Atención',
            type: 'basic',
            icon: 'heroicons_outline:building-office-2',
            link: '/lugares-de-atencion',
        },
        {
            id: 'transacciones',
            title: 'Transacciones',
            type: 'basic',
            icon: 'heroicons_outline:arrows-right-left',
            link: '/transacciones',
        },
        {
            id: 'tickets',
            title: 'Tickets',
            type: 'basic',
            icon: 'heroicons_outline:clipboard-document-list',
            link: '/tickets',
        },
        {
            id: 'transcodificaciones',
            title: 'Transcodificaciones',
            type: 'basic',
            icon: 'heroicons_outline:language',
            link: '/transcodificaciones',
        },
    ];
}

export function compactNavigation(role: string): FuseNavigationItem[] {
    return [
        {
            id: 'example',
            title: 'Example2',
            type: 'basic',
            icon: 'heroicons_outline:chart-pie',
            link: '/example',
        },
    ];
}
export function futuristicNavigation(role: string): FuseNavigationItem[] {
    return [
        {
            id: 'example',
            title: 'Example3',
            type: 'basic',
            icon: 'heroicons_outline:chart-pie',
            link: '/example',
        },
    ];
}
export function horizontalNavigation(role: string): FuseNavigationItem[] {
    return [
        // {
        //     id: 'admin',
        //     title: 'Administrador',
        //     type: 'basic',
        //     icon: 'heroicons_outline:computer-desktop',
        //     link: '/admin'
        // },
        {
            id: 'financiadores',
            title: 'Financiadores',
            type: 'basic',
            icon: 'heroicons_outline:briefcase',
            link: '/financiadores',
        },
        {
            id: 'prestadores',
            title: 'Prestadores',
            type: 'basic',
            icon: 'heroicons_outline:user-group',
            link: '/prestadores',
        },
        {
            id: 'lugares-atencion',
            title: 'Lugares de Atención',
            type: 'basic',
            icon: 'heroicons_outline:building-office-2',
            link: '/lugares-de-atencion',
        },
        {
            id: 'transacciones',
            title: 'Transacciones',
            type: 'basic',
            icon: 'heroicons_outline:arrows-right-left',
            link: '/transacciones',
        },
        {
            id: 'pasaportes',
            title: 'Pasaportes',
            type: 'basic',
            icon: 'heroicons_outline:credit-card',
            link: '/pasaportes',
        },
        {
            id: 'tickets',
            title: 'Tickets',
            type: role.includes('admin') ? 'collapsable' : 'basic',
            icon: 'heroicons_outline:clipboard-document-list',
            link: '/tickets',
            children: role.includes('admin')
                ? [
                    {
                        id: 'admin',
                        title: 'Listar tickets',
                        type: 'basic',
                        icon: 'heroicons_outline:clipboard-document-list',
                        link: '/tickets/lista'
                    },
                    {
                        id: 'admin.tipificaciones',
                        title: 'Tipificaciones',
                        type: 'basic',
                        icon: 'heroicons_outline:list-bullet',
                        link: '/tickets/tipificaciones',
                    },
                    {
                        id: 'admin.tags',
                        title: 'Etiquetas',
                        type: 'basic',
                        icon: 'heroicons_outline:tag',
                        link: '/tickets/etiquetas',
                    },
                ]
                : [],
        },
        {
            id: 'transcodificaciones',
            title: 'Transcodificaciones',
            type: 'basic',
            icon: 'heroicons_outline:language',
            link: '/transcodificaciones',
        },
        {
            id: 'sistemas',
            title: 'Sistemas',
            type: 'basic',
            icon: 'heroicons_outline:computer-desktop',
            link: '/sistemas',
        },
        {
            id: 'pruebas',
            title: 'Pruebas',
            type: 'basic',
            icon: 'heroicons_outline:command-line',
            link: '/pruebas',
        },
        {
            id: 'estadisticas',
            title: 'Estadísticas',
            type: 'basic',
            icon: 'heroicons_outline:chart-bar',
            link: '/estadisticas',
        },
        {
            id: 'contactos',
            title: 'Contactos',
            type: 'basic',
            icon: 'heroicons_outline:phone',
            link: '/contactos',
        },
        {
            id: 'usuarios',
            title: 'Usuarios',
            type: 'basic',
            icon: 'heroicons_outline:users',
            link: '/usuarios',
        },
        {
            id: 'administracionIIS',
            title: 'Administración IIS',
            type: 'basic',
            icon: 'heroicons_outline:adjustments-horizontal',
            link: '/administracion-iis',
        },
        {
            id: 'administracionServicios',
            title: 'Administración servicios',
            type: 'basic',
            icon: 'heroicons_outline:server',
            link: '/administracion-servicios',
        },
        {
            id: 'asociaciones',
            title: 'Asociaciones',
            type: 'basic',
            icon: 'heroicons_outline:squares-plus',
            link: '/asociaciones',
        },
        {
            id: 'ayuda',
            title: 'Ayuda',
            type: 'basic',
            icon: 'heroicons_outline:information-circle',
            link: '/ayuda',
        },
    ];
}

export function horizontalExternalNavigation(
    role: string,
): FuseNavigationItem[] {
    return [
        {
            id: 'prestadores',
            title: 'Prestadores',
            type: 'basic',
            icon: 'heroicons_outline:user-group',
            link: '/prestadores',
        },
        {
            id: 'lugares-atencion',
            title: 'Lugares de Atención',
            type: 'basic',
            icon: 'heroicons_outline:building-office-2',
            link: '/lugares-de-atencion',
        },
        {
            id: 'transacciones',
            title: 'Transacciones',
            type: 'basic',
            icon: 'heroicons_outline:arrows-right-left',
            link: '/transacciones',
        },
        {
            id: 'tickets',
            title: 'Tickets',
            type: 'basic',
            icon: 'heroicons_outline:clipboard-document-list',
            link: '/tickets',
        },
        {
            id: 'transcodificaciones',
            title: 'Transcodificaciones',
            type: 'basic',
            icon: 'heroicons_outline:language',
            link: '/transcodificaciones',
        },
    ];
}
